import {
  HM_FIELD_TITLE_NAME,
  UNIT_FIELD_HM_VAL_NAMES,
  UNIT_FIELD_VAL_NAMES,
  UnitFieldValName,
} from "constant/dl_unit/dl_unit_field.constant";
import {
  UNIT_EXCEL_FIELD_TYPES,
  UnitExcelFieldType,
} from "constant/dl_unit/dl_unit_file_field.constant";
import { UNIT_TYPES, UnitType } from "constant/dl_unit/unit_type.constant";
import { UnitFields, UnitFVals } from "type/dl_unit/dl_unit.type";

export function formatUnitExcelData(data: any[]): UnitFields[] {
  const fields: UnitFields[] = [];

  if (data.length >= 1) {
    const firstRow = data[0];

    const fieldType: UnitExcelFieldType | "" = unitExcelFieldTypeGet(firstRow);

    if (fieldType) {
      for (let i = 0; i < data.length; i++) {
        const unitData = data[i];
        const fVals = unitExcelRowFValsGet(fieldType, unitData);
        const unitFields: UnitFields = { fVals };
        const slug: string = unitExcelRowSlugGet(unitData);
        if (slug) {
          unitFields.slug = slug;
        }
        const uType: UnitType | "" = unitExcelRowUTypeGet(fieldType, unitData);
        if (uType) {
          unitFields.uType = uType;
        }
        fields.push(unitFields);
      }
    }
  }

  return fields;
}

function unitExcelFieldTypeGet(firstRow: any): UnitExcelFieldType | "" {
  let fieldType: UnitExcelFieldType | "" = "";
  if ("Naslov" in firstRow) {
    fieldType = UNIT_EXCEL_FIELD_TYPES.HM2_DESCRIPTIVE;
  } else {
    fieldType = UNIT_EXCEL_FIELD_TYPES.HM2;
    for (const fName of Object.keys(firstRow)) {
      if (fName !== "slug" && !UNIT_FIELD_HM_VAL_NAMES.includes(fName)) {
        fieldType = UNIT_EXCEL_FIELD_TYPES.ALL;
        break;
      }
    }
  }

  return fieldType;
}

function unitExcelRowSlugGet(row: { [key: string]: string | number }): string {
  let slug: string = "";
  if ("slug" in row && row.slug) {
    slug = row.slug as string;
  }

  return slug;
}

function unitExcelRowUTypeGet(
  fieldType: UnitExcelFieldType,
  row: {
    [key: string]: string | number;
  },
): UnitType | "" {
  let uType: UnitType | "" = "";
  if (fieldType === UNIT_EXCEL_FIELD_TYPES.HM2_DESCRIPTIVE) {
    uType = UNIT_TYPES.HM2;
  } else if ("uType" in row && row.uType) {
    uType = row.uType as UnitType;
  }

  return uType;
}

function unitExcelRowFValsGet(
  fieldType: UnitExcelFieldType,
  row: { [key: string]: string | number },
): UnitFVals {
  const fVals: UnitFVals = {};

  for (const [key, value] of Object.entries(row)) {
    if (fieldType === UNIT_EXCEL_FIELD_TYPES.HM2_DESCRIPTIVE) {
      if (key in HM_FIELD_TITLE_NAME) {
        const fName: UnitFieldValName = HM_FIELD_TITLE_NAME[key];
        fVals[fName] = value as string;
      }
    } else if (fieldType === UNIT_EXCEL_FIELD_TYPES.HM2) {
      if (UNIT_FIELD_HM_VAL_NAMES.includes(key)) {
        fVals[key] = value as string;
      }
    } else if (fieldType === UNIT_EXCEL_FIELD_TYPES.ALL) {
      if (UNIT_FIELD_VAL_NAMES.includes(key)) {
        fVals[key] = value as string;
      }
    }
  }

  return fVals;
}
